import { useRef } from 'react';
import ModalHandler from '@app/component/overlays/modal/ModalHandler';

const useModal = <T>() => {

	const modal = useRef<ModalHandler>(null);

	const open = (value?: T) => {
		modal.current!.open(value);
	};

	const close = () => {
		modal.current!.close();
	};

	const isOpen = () => {
		return !!modal.current && modal.current!.isOpen();
	};

	const getModalHtmlElement = () => {
		return !!modal.current ? modal.current!.getModalHtmlElement() : null;
	};

	return {
		ref: modal,
		open: open,
		close: close,
		isOpen: isOpen,
		getModalHtmlElement: getModalHtmlElement,
	};
};

export default useModal;